import { Action } from '@ngrx/store';

export function HideLoader(...triggerActionTypes: string[]) {
  return function (actionClass: new (...args: any[]) => Action) {
    Object.defineProperty(actionClass.prototype, 'triggerActionType', {
      value: triggerActionTypes.join('$'),
    });
  };
}
